'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExperimentEnabled = exports.getExperimentsJsonP = exports.getExperiments = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _sendRequest = require('../utils/send-request');

var _promise = require('../utils/promise');

var WMP = window.WMP = window.WMP || {};
WMP.callbacks = {
  counter: 0
};
var retrievedExperiments = {};

var getExperiments = exports.getExperiments = memoizeExperiment(function (scope, timeout) {
  return Promise.all([(0, _sendRequest.sendRequest)({
    url: '//www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=' + scope,
    withCredentials: true,
    timeout: timeout
  }), getExperimentQueryOverride()]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        data = _ref2[0].data,
        overrides = _ref2[1];

    return _extends({}, normalize(data), overrides);
  });
});

var getExperimentsJsonP = exports.getExperimentsJsonP = memoizeExperiment(function (scope, timeout) {
  if (!scope) {
    throw new Error('Experiment scope is not provided');
  }
  var url = '//www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=' + scope + '&accept=jsonp';
  return Promise.all([getJsonp(url, timeout), getExperimentQueryOverride()]).then(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        experiments = _ref4[0],
        overrides = _ref4[1];

    return _extends({}, normalize(experiments), overrides);
  });
});

var isExperimentEnabled = exports.isExperimentEnabled = function isExperimentEnabled(scope, name, timeout) {
  if (!name) {
    throw new Error('Experiment name is not specified');
  }
  return getExperiments(scope, timeout).then(function (experiments) {
    return experiments[name] === true;
  });
};

function memoizeExperiment(fn) {
  return function (key) {
    if (!retrievedExperiments[key]) {
      retrievedExperiments[key] = fn.apply(undefined, arguments);
    }
    return retrievedExperiments[key];
  };
}

function getExperimentQueryOverride() {
  return Promise.resolve().then(function () {
    return Promise.all([WMP.wixUtils.getQuery(document.referrer).experiments, WMP.wixUtils.getQuery().experiments, getRefererFromWixSdk(500).catch(function (reason) {
      console.warn('Cannot get experiment override from SDK', reason); //eslint-disable-line no-console
      return '';
    })]);
  }).then(function (experimentOverrides) {
    return experimentOverrides.map(function (override) {
      return override && override.split(',');
    }).filter(Boolean).reduce(function (overrides, arr) {
      return overrides.concat(arr);
    }, []).filter(Boolean).reduce(function (acc, experiment) {
      var _experiment$split = experiment.split(':'),
          _experiment$split2 = _slicedToArray(_experiment$split, 2),
          name = _experiment$split2[0],
          value = _experiment$split2[1];

      acc[name] = value === undefined ? true : value;
      return acc;
    }, {});
  }).catch(function (reason) {
    console.error(reason); //eslint-disable-line no-console
    return {};
  });
}

function getRefererFromWixSdk(timeout) {
  var promise = new Promise(function (resolve) {
    if (!window.Wix || !window.Wix.getSiteInfo || window.Wix.Utils.getViewMode() !== 'editor') {
      resolve('');
    }
    window.Wix.getSiteInfo(function (siteInfo) {
      resolve(WMP.wixUtils.getQuery(siteInfo.referer).experiments);
    });
  });

  return (0, _promise.addTimeout)(promise, { time: timeout, reason: 'WIx Sdk Timeout (getSiteInfo)' });
}

function getJsonp(path, timeout) {
  return new Promise(function (resolve, reject) {
    var timerId = void 0;
    var callBackName = '_' + WMP.callbacks.counter++;
    var url = path + '&callback=WMP.callbacks.' + callBackName;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    if (timeout) {
      timerId = setTimeout(function () {
        reject(new Error('Experiments load timeout'));
        cleanup({});
      }, timeout);
    }

    function cleanup() {
      document.body.removeChild(script);
      WMP.callbacks[callBackName] = function () {};
      if (timeout) {
        clearTimeout(timerId);
      }
    }

    WMP.callbacks[callBackName] = function () {
      var result = arguments.length > 1 ? arguments[arguments.length - 1] : undefined;
      resolve(result);
      cleanup();
    };
    script.onerror = function () {
      reject(new Error('Error during experiments retrieve'));
      cleanup();
    };

    script.src = url;
    document.body.appendChild(script);
  });
}

function normalize(rawExperiments) {
  return Object.keys(rawExperiments).reduce(function (experiments, experimentName) {
    var experimentValue = rawExperiments[experimentName];
    try {
      experimentValue = JSON.parse(experimentValue);
    } catch (ex) {
      // value is not serialized, use as is
    }
    var experimentValueMapper = {
      new: true,
      old: false
    };
    experimentValue = experimentValueMapper[experimentValue] || experimentValue;
    var normalizedName = experimentName.replace('specs.', '');
    experiments[normalizedName] = experimentValue;
    experiments[experimentName] = experimentValue;
    return experiments;
  }, {});
}
//# sourceMappingURL=experiment-manager.js.map



//////////////////
// WEBPACK FOOTER
// ../~/music-shared/dist/src/experiments/experiment-manager.js
// module id = 61
// module chunks = 9